import {
  createDocumentDomainHook,
  createDomainUpdateHook,
} from './domainHookFactory';
import { messagesTranslator } from './translators/messages';
import type { MessagesSettings } from './types';

export const useMessagesSettings = createDocumentDomainHook<MessagesSettings>(
  'messages',
  messagesTranslator,
);

export const useUpdateMessagesSettings =
  createDomainUpdateHook<MessagesSettings>(useMessagesSettings);
